import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import ContactFloat from "@/components/ContactFloat";
export default function Serve() {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language === "zh";

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("serve.title")}</title>
        <meta name="keywords" content={t("serve.keywords")} />
        <meta name="description" content={t("serve.description")} />
      </Helmet>
      <ContactFloat />
      <div className="bg-[#233c46]">
        <div
          className="w-full bg-[url('/images/serve_01.jpg')] bg-no-repeat bg-center "
          data-aos="fade-right"
          data-aos-offset="100"
          data-aos-duration="500"
        >
          <div className="w-full min-h-[320px] md:h-[400px] md:min-h-0 bg-black/40 relative">
            <div className="w-1200 mx-auto px-4 sm:px-6">
              <div className="text-center text-white pt-[120px] pb-16 md:pb-0 md:pt-[150px] relative">
                <h2
                  className="text-2xl sm:text-[28px] md:text-[30px] font-bold"
                  data-aos="fade-right"
                  data-aos-offset="100"
                  data-aos-duration="500"
                >
                  {t("serve.banner.title")}
                </h2>
                <span
                  className="block h-[4px] w-[50px] bg-white mx-auto mt-3"
                  data-aos-delay="300"
                  data-aos="zoom-in"
                ></span>
                <p
                  className="mt-5 text-base md:text-[18px] px-1"
                  data-aos="fade-left"
                  data-aos-offset="100"
                  data-aos-duration="500"
                >
                  {t("serve.banner.subtitle")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 服务内容 */}
      <div className="relative w-full bg-white pt-[60px]">
        <div className="w-1200 mx-auto px-4 sm:px-6">
          <h2
            className="font-bold text-[#222] text-2xl sm:text-3xl md:text-[34px] text-center pb-5"
            data-aos-delay="100"
            data-aos="fade-up"
          >
            {t("serve.content.title")}
          </h2>
          <p
            className="text-center text-[#666] text-base md:text-[18px] px-1"
            data-aos="fade-up"
          >
            {t("serve.content.subtitle")}
          </p>
          <div
            className="relative mt-[60px] max-md:min-h-0 md:min-h-[750px] md:pl-[582px] md:pr-0 bg-[url('/images/index12.jpg')] bg-no-repeat max-md:bg-size-[min(100%,420px)_auto] max-md:bg-position-[center_top] max-md:pt-[200px] md:pt-0 md:bg-bottom-left"
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
          >
            <div
              className="relative border border-[#ddd] p-4 pt-24 max-md:text-left md:p-[45px] md:pl-[160px] mb-[25px] hover:border-[#0f5f95]"
              data-aos="fade-left"
              data-aos-offset="100"
              data-aos-duration="500"
            >
              <div
                className="absolute left-1/2 top-4 h-[100px] w-[100px] -translate-x-1/2 bg-center bg-no-repeat md:left-[45px] md:top-[50px] md:translate-x-0"
                style={{ backgroundImage: "url('/images/serve_02.png')" }}
              />
              <h3 className="text-xl md:text-[24px] text-[#0f5f95] font-bold pb-[15px] text-center md:text-left">
                {t("serve.content.items.0.title")}
              </h3>
              <p className="leading-[26px] text-left">
                {t("serve.content.items.0.description")}
              </p>
            </div>

            <div
              className="relative border border-[#ddd] p-4 pt-24 max-md:text-left md:p-[45px] md:pl-[160px] mb-[25px] hover:border-[#0f5f95]"
              data-aos="fade-left"
              data-aos-offset="100"
              data-aos-duration="500"
            >
              <div
                className="absolute left-1/2 top-4 h-[100px] w-[100px] -translate-x-1/2 bg-center bg-no-repeat md:left-[45px] md:top-[24px] md:translate-x-0"
                style={{ backgroundImage: "url('/images/serve_03.png')" }}
              />
              <h3 className="text-xl md:text-[24px] text-[#0f5f95] font-bold pb-[15px] text-center md:text-left">
                {t("serve.content.items.1.title")}
              </h3>
              <p className="leading-[26px] text-left">
                {t("serve.content.items.1.description")}
              </p>
            </div>

            <div
              className="relative border border-[#ddd] p-4 pt-24 max-md:text-left md:p-[45px] md:pl-[160px] mb-[25px] hover:border-[#0f5f95]"
              data-aos="fade-left"
              data-aos-offset="100"
              data-aos-duration="500"
            >
              <div
                className="absolute left-1/2 top-4 h-[100px] w-[100px] -translate-x-1/2 bg-center bg-no-repeat md:left-[45px] md:top-[50px] md:translate-x-0"
                style={{ backgroundImage: "url('/images/serve_04.png')" }}
              />
              <h3 className="text-xl md:text-[24px] text-[#0f5f95] font-bold pb-[15px] text-center md:text-left">
                {t("serve.content.items.2.title")}
              </h3>
              <p className="leading-[26px] text-left">
                {t("serve.content.items.2.description")}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* 服务流程 */}
      <div className="relative w-full bg-[#f2f4f6] py-[60px]">
        <div className="w-1200 mx-auto px-4 sm:px-6">
          <h2
            className="font-bold text-[#222] text-2xl sm:text-3xl md:text-[34px] text-center pb-5"
            data-aos-delay="100"
            data-aos="fade-up"
          >
            {t("serve.flow.title")}
          </h2>
          <p
            className="text-center text-[#666] text-base md:text-[18px] px-1"
            data-aos="fade-up"
          >
            {t("serve.flow.subtitle")}
          </p>
          <div className="bg-white min-h-0 md:min-h-[360px] my-10 md:my-[60px] pt-8 md:pt-[60px]">
            <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 sm:gap-8 lg:grid-cols-4 lg:gap-6 px-4 sm:px-8 md:px-10">
              <div
                className={clsx(
                  "min-h-0 text-center sm:min-h-[280px] md:h-[300px]",
                  isZh
                    ? "[&>p]:px-4 [&>p]:text-[16px] [&>h3]:text-[20px]"
                    : "[&>p]:px-2 [&>p]:text-[14px] [&>h3]:text-[16px]"
                )}
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-easing="ease-in-sine"
              >
                <div
                  className="w-full h-[70px] bg-no-repeat bg-center"
                  style={{ backgroundImage: "url('/images/serve_06.png')" }}
                />
                <h3 className="text-[#121416] font-bold pt-[25px] pb-[10px] relative">
                  <span className="bg-white relative z-10 px-2">
                    {t("serve.flow.items.0.title")}
                  </span>
                  <span
                    className="absolute hidden h-[38px] w-[180px] lg:block"
                    style={{
                      backgroundImage: "url('/images/serve_10.png')",
                      backgroundRepeat: "no-repeat",
                      top: "28%",
                      left: "72%",
                    }}
                  />
                </h3>
                <p className="text-[#606264] leading-6 text-left">
                  {t("serve.flow.items.0.description")}
                </p>
              </div>

              <div
                className={clsx(
                  "min-h-0 text-center sm:min-h-[280px] md:h-[300px]",
                  isZh ? "[&>p]:px-4 [&>h3]:text-[20px]" : "[&>p]:px-2 [&>h3]:text-[16px]"
                )}
                data-aos="fade-right"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
              >
                <div
                  className="w-full h-[70px] bg-no-repeat bg-center"
                  style={{ backgroundImage: "url('/images/serve_07.png')" }}
                />
                <h3 className="text-[#121416] font-bold pt-[25px] pb-[10px] relative">
                  <span className="bg-white relative z-10 px-2">
                    {t("serve.flow.items.1.title")}
                  </span>
                  <span
                    className="absolute hidden h-[38px] w-[180px] lg:block"
                    style={{
                      backgroundImage: "url('/images/serve_10.png')",
                      backgroundRepeat: "no-repeat",
                      top: "28%",
                      left: "72%",
                    }}
                  />
                </h3>
                <p className="text-[#606264] leading-6 text-left">
                  {t("serve.flow.items.1.description")}
                </p>
              </div>

              <div
                className={clsx(
                  "min-h-0 text-center sm:min-h-[280px] md:h-[300px]",
                  isZh ? "[&>p]:px-4 [&>h3]:text-[20px]" : "[&>p]:px-2 [&>h3]:text-[16px]"
                )}
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <div
                  className="w-full h-[70px] bg-no-repeat bg-center"
                  style={{ backgroundImage: "url('/images/serve_08.png')" }}
                />
                <h3 className="text-[#121416] font-bold pt-[25px] pb-[10px] relative">
                  <span className="bg-white relative z-10 px-2">
                    {t("serve.flow.items.2.title")}
                  </span>
                  <span
                    className="absolute hidden h-[38px] w-[180px] lg:block"
                    style={{
                      backgroundImage: "url('/images/serve_10.png')",
                      backgroundRepeat: "no-repeat",
                      top: "28%",
                      left: "72%",
                    }}
                  />
                </h3>
                <p className="text-[#606264] leading-6 text-left">
                  {t("serve.flow.items.2.description")}
                </p>
              </div>

              <div
                className={clsx(
                  "min-h-0 text-center sm:min-h-[280px] md:h-[300px]",
                  isZh ? "[&>p]:px-4 [&>h3]:text-[20px]" : "[&>p]:px-2 [&>h3]:text-[16px]"
                )}
                data-aos="fade-right"
                data-aos-offset="400"
                data-aos-easing="ease-in-sine"
              >
                <div
                  className="w-full h-[70px] bg-no-repeat bg-center"
                  style={{ backgroundImage: "url('/images/serve_09.png')" }}
                />
                <h3 className="text-[#121416] font-bold pt-[25px] pb-[10px] relative">
                  <span className="bg-white relative z-10 px-2">
                    {t("serve.flow.items.3.title")}
                  </span>
                  {/* <span
                    className="block w-[180px] h-[38px] absolute"
                    style={{ backgroundImage: "url('/images/serve_10.png')", backgroundRepeat: 'no-repeat', top: '28%', left: '72%' }}
                  /> */}
                </h3>
                <p className="text-[#606264] leading-6 text-left">
                  {t("serve.flow.items.3.description")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 管理模式 */}
      <div className="relative w-full bg-white">
        <div className="w-1200 mx-auto relative overflow-hidden px-4 pt-[60px] sm:px-6">
          <h2
            className="font-bold text-[#222] text-2xl sm:text-3xl md:text-[34px] text-center pb-5"
            data-aos-delay="100"
            data-aos="fade-up"
          >
            {t("serve.management.title")}
          </h2>
          <p
            className="text-center text-[#666] text-base md:text-[18px] px-1"
            data-aos="fade-up"
          >
            {t("serve.management.subtitle")}
          </p>
          <div className="my-10 flex h-auto flex-col gap-8 bg-[#ecf4fa] py-6 pl-0 md:my-[60px] md:flex-row md:gap-10 md:pl-[40px] md:py-0 lg:justify-between">
            <div className="flex-1 pt-0 md:pt-[30px]">
              <div className="pt-6">
                <h3
                  className="text-xl md:text-[24px] text-[#0f5f95] font-bold pb-[18px]"
                  data-aos="fade-right"
                  data-aos-offset="50"
                >
                  {t("serve.management.double.title")}
                </h3>
                <span
                  className="block text-[18px] text-[#222] font-bold pb-[10px]"
                  data-aos="fade-right"
                  data-aos-offset="150"
                >
                  {t("serve.management.double.pm_ph")}
                </span>
                <p
                  className="leading-6 text-left pb-5"
                  data-aos="fade-right"
                  data-aos-offset="200"
                >
                  {t("serve.management.double.pm_ph_desc")}
                </p>
              </div>
              <div className="pt-6">
                <h3
                  className="text-xl md:text-[24px] text-[#0f5f95] font-bold pb-[18px]"
                  data-aos="fade-right"
                  data-aos-offset="250"
                >
                  {t("serve.management.kpi.title")}
                </h3>
                <p
                  className="leading-6 text-left pb-5"
                  data-aos="fade-right"
                  data-aos-offset="300"
                >
                  {t("serve.management.kpi.desc")}
                </p>
              </div>
            </div>

            <img
              src="/images/serve_11.png"
              alt="serve_11"
              className="w-full shrink-0 object-cover md:w-3/5"
              data-aos="fade-left"
              data-aos-offset="100"
              data-aos-duration="500"
            />
          </div>
        </div>
      </div>
    </>
  );
}
